; (function (inovestor, undefined) {
    // Setup dependencies for this plugin
    // Normally we would add jQuery and knockout but ms-core, which we depend on, already register them so it's useless

    // Create plugin namespace with any desired config variable
    inovestor.ms.stock = inovestor.ms.stock || {};
})(inovestor);


; (function (stock, undefined) {
    // Create plugin namespace with any desired config variable
    stock.fundamentals = {
        config: {
            apiRelativeUrl: 'stocks/financialstatement?symbol={symbol}&reporttype={reportType}&twoLetterISOLanguageName={twoLetterISOLanguageName}&processingtype={processingType}'
        }
    };

})(inovestor.ms.stock);


; (function ($, ko, inovestor, undefined) {

    inovestor.ms.stock.fundamentals.viewModels = {};

    inovestor.ms.stock.fundamentals.viewModels.fundamentalsViewModels = function () {
        var self = this;
        self.resources = ko.observable();
        self.hasError = ko.observable(false);
        self.isInvalidIdentifier = ko.observable(false);
        self.fundamentals = ko.observable();
        self.hasValidData = ko.computed(function () {
            return !self.hasError() && !self.isInvalidIdentifier() && self.fundamentals() != null;
        }, this);

        self.isDataSourceViewData = ko.observable(false);
        self.isDataSourceXbrl = ko.observable(false);

        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.stock.fundamentals.resources[inovestor.ms.core.currentLanguage];
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null;
            self.resources(currentResource);
        };
    }
})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsStockFundamentals';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsStockFundamentals.defaults;
        this._viewModel = new inovestor.ms.stock.fundamentals.viewModels.fundamentalsViewModels();

        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.symbol))
            throw "symbol is required";

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.reportType))
            throw "reportType is required";

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.processingType))
            throw "processingType is required";

        // Call init
        this.init();
    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin.update();
            });

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.fundamentals;
            var filePath = plugin.options.templatePaths.fundamentals;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'fundamentals.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.bindEvents();
                plugin.render();
                plugin.bindModel();
            }).then(function () {
                plugin.updateDataSource();
                plugin.adjustDefaultProcessingType();

                // Call Search
                plugin.search(plugin.options.symbol, plugin.options.reportType, plugin.options.processingType).always(function () {
                    // When search is completed, trigger onReady event
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
            this.$financialStatements = this.$element.find('.financialStatements');
            this.$financialStatementsInstance = null;
            this.$reportTypeSelect = this.$element.find('.report-type-select');
            this.$processingTypeSelect = this.$element.find('.processing-type-select');

            //FinancialStatements
            this.$incomeStatementView = null;
            this.$balanceSheetView = null;
            this.$cashFlowView = null;
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('initialized' + '.' + plugin._name, function () {
                var onInit = plugin.options.onInit;
                if (typeof onInit === 'function') {
                    onInit.call(plugin.$element);
                }
            });

            plugin.$reportTypeSelect.on('change' + '.' + plugin._name, function (event) {
                var reportType = plugin.$reportTypeSelect.val();
                plugin.search(plugin.options.symbol, reportType, plugin.options.processingType);
            });

            plugin.$processingTypeSelect.on('change' + '.' + plugin._name, function (event) {
                var processingType = plugin.$processingTypeSelect.val();
                plugin.search(plugin.options.symbol, plugin.options.reportType, processingType);
            });

            plugin.$element.on('click' + '.' + plugin._name, function (event) {
                if (event && event.originalEvent) {
                    if ($(event.originalEvent.target).hasClass('nav-incomeStatement')) {
                        plugin.renderIncomeStatement();
                    }
                    if ($(event.originalEvent.target).hasClass('nav-cashFlow')) {
                        plugin.renderCashFlow();
                    }
                    if ($(event.originalEvent.target).hasClass('nav-balanceSheet')) {
                        plugin.renderBalanceSheet();
                    }
                }
                //plugin.renderBalanceSheet();
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
            this.$element.find('.report-type-select').off('.' + this._name);
        },

        updateDataSource: function () {
            var plugin = this;

            if (plugin.options.symbol.toLowerCase().startsWith('xtse:') || plugin.options.symbol.toLowerCase().startsWith('xtsx:')) {
                plugin._viewModel.isDataSourceViewData(true);
            }
            else {
                plugin._viewModel.isDataSourceViewData(false);
            }
            if (plugin.options.symbol.toLowerCase().startsWith('xnys') || plugin.options.symbol.toLowerCase().startsWith('xnas') || plugin.options.symbol.toLowerCase().startsWith('ootc') || plugin.options.symbol.toLowerCase().startsWith('xase')) {
                plugin._viewModel.isDataSourceXbrl(true);
            }
            else {
                plugin._viewModel.isDataSourceXbrl(false);
            }
        },

        adjustDefaultProcessingType: function () {
            var plugin = this;

            //for companies from ViewData, we support displaying only normalized reports
            if (plugin._viewModel.isDataSourceViewData()) {
                plugin.options.processingType = 'normalized';
            }
        },

        // Search for a particular fund
        search: function (symbol, reportType, processingType) {
            var plugin = this;

            // Make sure required variables are set
            if (inovestor.ms.core.isNullOrUndefined(symbol))
                throw "symbol is required";
            if (inovestor.ms.core.isNullOrUndefined(reportType))
                throw "reportType is required";
            if (inovestor.ms.core.isNullOrUndefined(processingType))
                throw "processingType is required";

            // Update options
            plugin.options.symbol = symbol;
            plugin.options.reportType = reportType;
            plugin.options.processingType = processingType;

            plugin.updateDataSource();

            // Update report type drop down to match the request
            plugin.$reportTypeSelect.val(reportType);

            // Update processing type drop down to match the request
            plugin.$processingTypeSelect.val(processingType);

            //Reset FinancialStatements views
            if (this.$incomeStatementView) {
                this.$incomeStatementView.destroy();
                this.$incomeStatementView = null;
            }
            if (this.$balanceSheetView) {
                this.$balanceSheetView.destroy();
                this.$balanceSheetView = null;
            }
            if (this.$cashFlowView) {
                this.$cashFlowView.destroy();;
                this.$cashFlowView = null;
            }

            // Reset relevant Data before calling API
            plugin._viewModel.fundamentals(null);
            plugin._viewModel.hasError(false);
            plugin._viewModel.isInvalidIdentifier(false);

            // Setup API url with term
            var stockfinancialStatementsUrl = inovestor.ms.core.stringFormat(inovestor.ms.stock.fundamentals.config.apiRelativeUrl, { symbol: symbol, reportType: reportType, twoLetterISOLanguageName: inovestor.ms.core.currentLanguage, processingType: processingType });

            // Call API and bind model
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };
            return inovestor.ms.core.ajaxApi(stockfinancialStatementsUrl, options).then(function (data) {
                if (!inovestor.ms.core.isNullOrUndefined(data)) {

                    if (data.requestStatus === 'invalidIdentifier')
                        plugin.invalidIdentifierHandler();

                    data.incomeStatement.contextId = "incomeStatment";
                    data.cashFlow.contextId = "cashFlow";
                    data.balanceSheet.contextId = "balanceSheet";

                    plugin._viewModel.fundamentals(data);
                    plugin.renderIncomeStatement();
                }

                plugin.update();
            });
        },

        // Invalid Identifier error handler
        invalidIdentifierHandler: function () {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.invalidIdentifier, null, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.isInvalidIdentifier(true);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasError(true);
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        // Update resources
        update: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
            plugin._viewModel.fundamentals.valueHasMutated();
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        },

        renderIncomeStatement: function () {
            var plugin = this;
            var incomeStatementElement = plugin.$element.find('.statement-incomeStatement');
            if (!plugin.$incomeStatementView && plugin._viewModel.fundamentals()) {
                if (incomeStatementElement.length > 0 && plugin._viewModel.fundamentals()) {
                    plugin.$incomeStatementView = incomeStatementElement
                        .inoMsStockFinancialStatements({ statement: plugin._viewModel.fundamentals().incomeStatement })
                        .data('inoMsStockFinancialStatements');
                }
            }
        },

        renderBalanceSheet: function () {
            var plugin = this;
            var balanceSheetElement = plugin.$element.find('.statement-balanceSheet');
            if (!plugin.$balanceSheetView) {
                if (balanceSheetElement.length > 0 && plugin._viewModel.fundamentals()) {
                    plugin.$balanceSheetView = balanceSheetElement
                        .inoMsStockFinancialStatements({ statement: plugin._viewModel.fundamentals().balanceSheet })
                        .data('inoMsStockFinancialStatements');
                }
            }
        },

        renderCashFlow: function () {
            var plugin = this;
            var cashFlowElement = plugin.$element.find('.statement-cashFlow');
            if (!plugin.$cashFlowView) {
                if (cashFlowElement.length > 0 && plugin._viewModel.fundamentals()) {
                    plugin.$cashFlowView = cashFlowElement
                        .inoMsStockFinancialStatements({ statement: plugin._viewModel.fundamentals().cashFlow })
                        .data('inoMsStockFinancialStatements');
                }
            }
        }
    });

    // JQuery Plugin wrapper
    $.fn.inoMsStockFundamentals = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsStockFundamentals.defaults = {
        symbol: null,
        reportType: 'annual',
        processingType: 'asFiled',
        onError: null,
        onReady: null,
        templatePaths: {
            fundamentals: null
        }
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (stock, undefined) {
    stock.fundamentals.resources = stock.fundamentals.resources || {};
    stock.fundamentals.resources["en"] = {
        periodsLabel: 'Periods',
        reportTypeAnnually: 'Annual',
        reportTypeQuarterly: 'Quarterly',
        processingTypeLabel: 'Processing type',
        processingTypeAsFiled: 'As filed',
        processingTypeNormalized: 'Normalized',
        incomeStatement: {
            title: 'Income Statement',
        },
        cashFlow: {
            title: 'Cash Flow',
        },
        balanceSheet: {
            title: 'Balance Sheet',
        },
    };
})(inovestor.ms.stock);
; (function (stock, undefined) {
    stock.fundamentals.resources = stock.fundamentals.resources || {};
    stock.fundamentals.resources["fr"] = {
        periodsLabel: 'Périodes',
        reportTypeAnnually: 'Annuel',
        reportTypeQuarterly: 'Trimestriel',
        processingTypeLabel: 'Type de traitement',
        processingTypeAsFiled: 'Tel que déposé',
        processingTypeNormalized: 'Normalisé',
        incomeStatement: {
            title: 'Résultats'
        },
        cashFlow: {
            title: 'Flux de trésorerie'
        },
        balanceSheet: {
            title: 'Bilan'
        },
    };
})(inovestor.ms.stock);